import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";

const apiClient = createApiClient("jsonld");
const RESEND_PROMO_URL = "/api/vpn/employee_promos/resent";

export const resendPromoSchema: DataProviderSchema<
  "EmployeePromoResent",
  "jsonld"
> = {
  list: () =>
    Promise.resolve({
      data: [],
      total: 0,
    }),
  create: (async ({ data: { email } }: { data: { email: string } }) => {
    await apiClient.POST(RESEND_PROMO_URL, {
      body: { email: String(email) },
    });

    return {
      data: { id: String(email) },
    };
  }) as unknown as NonNullable<
    DataProviderSchema<"EmployeePromoResent", "jsonld">["create"]
  >,
};
